import { SET_NAVBAR_MENU } from "../actionTypes";

const initialState = {
    showMenu: false,
    currentCategory: "",
};

export const navbarReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_NAVBAR_MENU:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
